angular.module('app').directive("addElement", [
    '$document',
    '$compile',
    '$parse',
    function ($document, $compile, $parse) {
        return {
            restrict: "E",
            replace: true,
            template: '<select chosen><option value="" selected hidden>{{placeholder}}</option></select>',
            scope: {
                options: '=',
                triggerBy: '=?',
                triggerElement: '=?',
                template: '=?',
                templateWrap: '=?',
                inputPlaceholder: '=',
                placeholder: '=?'
            },
            controller: function($scope, $element, $attrs) {
                var selectElement = $element,
                    getOptionsKey = function (model) {
                        return model + 'Options';
                    },
                    optionsKey = getOptionsKey($attrs['ngModel']);

                $scope.$parent.$watch($attrs["ngModel"], function (newValue, oldValue) {
                    if(newValue === '' && oldValue !== ''){
                        $scope.$parent[$attrs['ngModel']] = oldValue;
                    }
                });

                $scope.usedOptions = {};
                $scope.optionsRelations = {};
                $scope.initialOptions = angular.copy($scope.options);
                $scope.options = [];
                $scope.placeholder = $scope.placeholder  || 'Select';

                angular.forEach($scope.initialOptions, function (option, key) {
                    if (key == 0) {
                        $scope.options.push({
                            key: null,
                            value: ''
                        });
                    }// fixed bug of select first option

                    ++ key;
                    $scope.optionsRelations[option.id] = key;

                    var optionData = {
                        key: option.id,
                        value: option.title,
                    };

                    if (option.placeholder != undefined) {
                        optionData.placeholder = option.placeholder;
                    }

                    $scope.options.push(optionData);
                });

                $scope.$parent[optionsKey] = angular.copy($scope.options);
                selectElement.attr('ng-options', 'option.key as option.value for option in ' + optionsKey + ' track by option.key');
                // selectElement.attr('ng-model', $attrs['model']);
                // $element.removeAttr('model');
                // $element.removeAttr('options');

                $compile(selectElement[0])($scope.$parent);

                selectElement.find('option').eq(1).attr('selected','selected');

                setDefaultValues($attrs, {
                    inputFormat: 'DD/MM/YYYY',
                    templateWrap: 'addElementTemplateWrap'
                });

                setDefaultValues($scope, {
                    triggerBy: 'change',
                    templateWrap: $attrs['templateWrap'],
                    inputType: $attrs['inputType'],
                    inputValue: $attrs['inputValue'],
                    inputFormat: $attrs['inputFormat'],
                    inputValueFor: $parse($attrs['inputValueFor'])()
                });


                function filterOptions(optionsKey) {
                    var tmpOptions = [],
                        i = 0;

                    angular.forEach($scope.options, function (option) {

                        if ($scope.usedOptions[option.key] != undefined) {
                            return true;
                        }

                        $scope.optionsRelations[option.key] = i;
                        tmpOptions.push(option);
                        i ++;
                    });
                    $scope.$parent[optionsKey] = angular.copy(tmpOptions);
                    tmpOptions = undefined;
                }


                function getOptionByValue(value) {
                    return $scope.$parent[optionsKey][$scope.optionsRelations[value]];
                }

                $scope.addElementDateTimePicker = function (dateTime, dateToSave) {
                    setInputValue(dateTime, getAddElementsModelKey(), this.element.getAttribute('ng-key'));
                    saveInputValue();
                };

                $scope.unuse = function (value, $event) {
                    value = value || $event.currentTarget.getAttribute('selected');
                    var el = $scope.usedOptions[value];
                    if (el == undefined) {
                        return false;
                    }

                    el.remove();
                    delete $scope.usedOptions[value];

                    var inputModelKey = getAddElementsModelKey();

                    if ($scope.$parent[inputModelKey] != undefined && $scope.$parent[inputModelKey][value] != undefined) {
                        delete $scope.$parent[inputModelKey][value];
                    }

                    filterOptions(getOptionsKey($attrs['ngModel']));
                };

                function unuseAll(model) {
                    var inputModelKey = getAddElementsModelKey(model);

                    angular.forEach($scope.usedOptions, function (el, optionId) {
                        if (!(el instanceof Object)) {
                            return true;
                        }

                        el.remove();
                        delete $scope.usedOptions[optionId];

                        if ($scope.$parent[inputModelKey] != undefined && $scope.$parent[inputModelKey][optionId] != undefined) {
                            delete $scope.$parent[inputModelKey][optionId];
                        }
                    });

                    filterOptions(getOptionsKey($attrs['ngModel']));
                }

                $scope.$parent.useAddElementHelper = function () {
                    return {
                        fetchData: function (model) {
                            var key = getAddElementsModelKey(model);

                            return $scope.$parent[key];
                        },
                        reset: function (model) {
                            unuseAll(model);
                        }
                    }
                };

                function getInputByType(type, selectedOption) {

                    var input = '<input class="form-control" ',
                        placeholder = selectedOption.placeholder != undefined
                            ? selectedOption.placeholder
                            : $scope.inputPlaceholder;

                    switch (type)
                    {
                        case 'date':
                            input += 'date-time-picker pick12hourformat="false" format="DD/MM/YYYY" cb="addElementDateTimePicker" ';
                            break;
                    }

                    if (placeholder != undefined) {
                        input += 'placeholder="' + placeholder + '"'
                    }

                    input += '>';

                    return input;
                }

                function getModel() {
                    return $attrs['ngModel'];
                }

                function getAddElementsModelKey(model) {
                    var model = model || getModel();

                    return model + 'AddElements'
                }

                function setInputValue(value, modelKey, valueKey) {
                    if ($scope[modelKey] == undefined) {
                        $scope[modelKey] = {};
                    }

                    $scope[modelKey][valueKey] = value;

                    saveInputValue();
                }

                function saveInputValue() {
                    var modelKey = getAddElementsModelKey();

                    $scope.$parent[modelKey] = $scope[modelKey];
                }

                $scope.onInputChange =  function () {
                    saveInputValue();
                };

                return {
                    getSelectElement: function () {
                        return selectElement;
                    },
                    use: function (modelName, optionValue, element) {
                        var optionsKey = this.getOptionsKey(modelName);

                        $scope.usedOptions[optionValue] = element;

                        filterOptions(optionsKey);
                    },
                    getDefaultTemplate: function (selected) {
                        var template =
                            '<div class="col-12">' +
                            '<label class="label-holder">' +
                            '<p>' + selected.value + '</p>' +
                            '<input-holder><icon class="fa-trash" ng-click="unuse(' + selected.key + ', $event)" selected="' + selected.key + '"></icon>'+getInputByType($scope.inputType, selected)+'</input-holder>'+
                            '</label>' +
                            '</div>';

                        return template;
                    },
                    append: function (value) {
                        var selected = this.getOptionByValue(value),
                            template = this.getDefaultTemplate(selected);

                        template = $compile(template)($scope);

                        var input = template.find('input'),
                            inputModelKey = this.getAddElementsModelKey();

                        input.attr('ng-model', inputModelKey + '["' + selected.key + '"]');
                        input.attr('ng-key', selected.key );

                        this.setInputValue('', getAddElementsModelKey(this.getModel()), selected.key);
                        this.saveInputValue();

                        if ($scope.inputValue != undefined) {

                            if ($scope.inputValueFor != undefined) {

                                if ($scope.inputValueFor.indexOf(parseInt(selected.key)) !== -1) {
                                    this.setInputValue(this.getInputValue(), inputModelKey, selected.key);
                                }

                            } else {
                                this.setInputValue(this.getInputValue(), inputModelKey, selected.key);
                            }
                        }

                        template = $compile(template)($scope);
                        // $scope.$apply();

                        input.on('change', $scope.onInputChange);

                        $document.find($scope.templateWrap).append(template);

                        this.use(this.getModel(), selected.key, template);
                    },
                    setInputValue: setInputValue,
                    getInputValue: function () {
                        var value = $scope.inputValue;

                        switch ($scope.inputType) {
                            case 'date':
                                if (value[0] == '+') {
                                    value = moment().add(value[1], 'month').format($scope.inputFormat);
                                }
                                break;
                        }

                        return value;
                    },
                    saveInputValue: saveInputValue,
                    getModel: getModel,
                    getAddElementsModelKey: getAddElementsModelKey,
                    getOptionByValue: getOptionByValue,
                    getOptionsKey : getOptionsKey
                };
            },
            link: function (scope, element, attributes, ctrl) {
                var ngModel = ctrl.getModel();
                select = ctrl.getSelectElement();

                if (typeof scope.$parent[ngModel] == 'object') {
                    var modelKey = ctrl.getAddElementsModelKey(ngModel);
                    angular.forEach(scope.$parent[ngModel], function (inputText, optionValue) {
                        ctrl.append(optionValue);
                        ctrl.setInputValue(inputText, modelKey, optionValue);
                    });
                }
                select.on(scope.triggerBy, function (event) {
                    scope.usedOptions[null] = '';

                    if (scope.$parent[ngModel] != '') {
                        ctrl.append(scope.$parent[ngModel]);
                    }
                });
            }
        }
    }
]);
